import type { WClientTestimonialsTranslations } from "./pl";

export const en: WClientTestimonialsTranslations = {
  defaultTitle: "Client testimonials",
  prev: "Previous",
  next: "Next",
  goToSlide: "Go to testimonial",
  readRealization: "See realization",
};
